<template>
    <el-card>
        <div class="course-content material-index is-always-shadow">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane
                    :label="$t('Client.Measure.title')"
                    name="first"
                    :lazy="true">
                    <measure-index
                        v-if="show === 'index'"
                        @fetchData="fetchData"
                        @handleData="handleData"
                        :show.sync="show"
                        :tableData="tableData"
                        :pagination="pagination" />
                    <measure-show
                        v-else
                        :clientId="clientId"
                        @fetchData="fetchData"
                        :show.sync="show"
                        :showData.sync="showData" />
                </el-tab-pane>
            </el-tabs>
        </div>
    </el-card>
</template>

<script>
import { Tabs, TabPane } from 'element-ui';
import MeasureIndex from '@/components/widget/Measurement/MeasureIndex';
import MeasureShow from '@/components/widget/Measurement/MeasureShow';

export default {
    components: {
        ElTabs: Tabs,
        ElTabPane: TabPane,
        MeasureIndex,
        MeasureShow,
    },
    data() {
        return {
            editableTabs: [
                {
                    name: 'first',
                    isShow: true,
                },
            ],
            clientId: this.$route.query.client,
            pagination: {
                page: 1,
                size: 50,
                total: 1,
            },
            tableData: [{date: 1}],
            show: 'index',
            showData: {},
        };
    },
    mixins: [require('../../mixins/CacheQuery').default],
    methods: {
        handleClick(tab, event) {},
        async fetchData(page = null) {
            if (page) this.pagination.page = page;
            await API.get(`client/${this.clientId}/body-test`, {
                params: {
                    page: this.pagination.page,
                    size: this.pagination.size,
                },
            }).then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
            });
        },
        handleData(val) {
            this.showData = val;
        },
    },
    created() {
        this.fetchData();
    },
};

</script>
